import classNames from 'classnames';
import { FC } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import { highlightMatch } from '../../../utils';

import './TeamName.scss';

interface IProps {
  team: ITeam;
  className?: string;
  searchValue?: string;
}

const TeamName: FC<IProps> = ({ team, className, searchValue }) => {
  const { name, isDeactivated, deactivatedAncestorId } = team;
  const displayName = name || '*NEW TEAM*';

  return (
    <div className={classNames('TeamName', className)}>
      <span>{searchValue ? highlightMatch(displayName, searchValue) : displayName}</span>
      {!!(isDeactivated || deactivatedAncestorId) && (
        <OverlayTrigger
          overlay={
            <Popover id={`course-unpublished-tooltip`}>
              <Popover.Content>Deactivated</Popover.Content>
            </Popover>
          }
        >
          <span className="material-icons-outlined pointer unpublished">unpublished</span>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default TeamName;
